import React, { useId } from 'react'

const TicketIcon = (props: React.SVGProps<SVGSVGElement>) => {
	const id = useId()

	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden {...props}>
			<g clipPath={`url(#clip-${id})`}>
				<path d='M7.5 4.375V15.625' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
				<path
					d='M1.875 12.5C2.53804 12.5 3.17393 12.2366 3.64277 11.7678C4.11161 11.2989 4.375 10.663 4.375 10C4.375 9.33696 4.11161 8.70107 3.64277 8.23223C3.17393 7.76339 2.53804 7.5 1.875 7.5V5C1.875 4.83424 1.94085 4.67527 2.05806 4.55806C2.17527 4.44085 2.33424 4.375 2.5 4.375H17.5C17.6658 4.375 17.8247 4.44085 17.9419 4.55806C18.0592 4.67527 18.125 4.83424 18.125 5V7.5C17.462 7.5 16.8261 7.76339 16.3572 8.23223C15.8884 8.70107 15.625 9.33696 15.625 10C15.625 10.663 15.8884 11.2989 16.3572 11.7678C16.8261 12.2366 17.462 12.5 18.125 12.5V15C18.125 15.1658 18.0592 15.3247 17.9419 15.4419C17.8247 15.5592 17.6658 15.625 17.5 15.625H2.5C2.33424 15.625 2.17527 15.5592 2.05806 15.4419C1.94085 15.3247 1.875 15.1658 1.875 15V12.5Z'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id={`clip-${id}`}>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default TicketIcon
